
import { useEffect, useRef, useState } from "react";
//import axios from "axios";
import "./ManagerCheckList.css";
import { useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import { fetchSubmittedApplicationsHR } from "../../../../services/complitedProfilesService";

const ManagerCheckList = () => {
  const [managerChecklist, setSubmitted] = useState([]);
  const [selectedApp, setSelectedApp] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const userId = storedUser?.userId;

  const effectRan = useRef(false);

  useEffect(() => {
    const fetchSubmitted = async () => {
      setLoading(true);
      try {
        const data = await fetchSubmittedApplicationsHR();
 // ✅ Ensure it's an array
      const list = Array.isArray(data) ? data : [];

      // ✅ Sort by timestamp descending (latest first)
      const sorted = list.sort((a, b) => {
        const t1 = new Date(a.personalInformation?.timestamp || 0);
        const t2 = new Date(b.personalInformation?.timestamp || 0);
        return t2 - t1; // descending order
      });

      setSubmitted(sorted);
      } catch (err) {
        console.error("Failed to load managerChecklist applications", err);
        setSubmitted([]);
      } finally {
        setLoading(false);
      }
    };
    if (!effectRan.current) {
      fetchSubmitted();
    }
    return () => {
      effectRan.current = true;
    }
  }, []);



  const handleClick = (app) => {
    navigate("/managerCheckListView", { state: { application: app } });
  };

  return (
    <div>
      <h2>Manager Checklist</h2>
      <div className="managerChecklist-table">
        {/* Always show header */}
        <div className="managerChecklist-header">
          {/* <div className="managerChecklist-col">Draft Id</div> */}
          <div className="managerChecklist-col">Full Name</div>
          <div className="managerChecklist-col">Job Position</div>
          <div className="managerChecklist-col">Submission Date and Time</div>
          <div className="managerChecklist-col">Updated By</div>
          <div className="managerChecklist-col">Status</div>
          <div className="managerChecklist-col">Action </div>
        </div>

        {/* Conditional row rendering */}
        {managerChecklist.map((app) => {
          const personalInfo = app.personalInformation;

          const formattedDateTime = personalInfo.timestamp
            ? format(new Date(personalInfo.timestamp), "dd-MM-yyyy , hh:mm a")
            : "—";

          return (
            <div key={personalInfo.id} className="managerChecklist-row">
              {/* Draft/Application Number */}
              {/* <div className="managerChecklist-col">{personalInfo.employeeUniqueId}</div> */}

              {/* Full Name */}
              <div className="managerChecklist-col">
                {`${personalInfo.fullName || ""}`}
              </div>
              <div className="managerChecklist-col">
                  {!app.personalInformation?.designation || app.personalInformation?.designation === "Not Assigned"
                    ? "N/A"
                    : app.personalInformation.designation} 
              </div>
              {/* Submission Date */}
              <div className="managerChecklist-col">{formattedDateTime}</div>
              <div className="managerChecklist-col">{app.filledByName}</div>
              {/* Status */}
              <div className="managerChecklist-col">
                {personalInfo.status
                  ? personalInfo.status.charAt(0).toUpperCase() +
                  personalInfo.status.slice(1).toLowerCase()
                  : "N/A"}
              </div>

              {/* View button */}
              <div className="managerChecklist-col">
                <button
                  className="managerChecklist-view-button"
                  onClick={() => handleClick(app)}
                >
                  Verification
                </button>
              </div>
            </div>
          );
        })}

      </div>

    </div>
  );
};

export default ManagerCheckList;
